import Button from '@components/Button';
import { FlexRow } from '@components/FlexRow';
import Text from '@components/Text';
import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Stack } from '@mui/material';

type Props = {
    onConfirm: () => void;
    onSkip: () => void;
} & DialogProps;

const PremiumOfferDialog = ({ onConfirm, onSkip, ...props }: Props) => {
    return (
        <Dialog
            {...props}
            PaperProps={{
                style: {
                    border: '4px solid #BDAE40',
                    borderRadius: 12,
                },
            }}>
            <DialogTitle>
                <Text bold heading size={28} dark>
                    Facilitez vos recrutements avec{' '}
                    <Text
                        bold
                        heading
                        size={28}
                        style={{
                            color: '#BDAE40',
                        }}>
                        l’offre Premium
                    </Text>
                </Text>
            </DialogTitle>
            <DialogContent>
                <Text size={16} darkGray>
                    Vous n'avez pas le temps de vous occuper du processus de recrutement ? Ne vous inquiétez pas ! Avec
                    l'option Premium, Upercut s'occupe de tout pour vous.
                </Text>
                <Stack style={{ gap: 24, marginTop: 24 }}>
                    <FlexRow gap={2}>
                        <i className="fi fi-br-magic-wand" style={{ fontSize: 32 }} />
                        <Stack style={{ flex: 1 }}>
                            <Text size={16} medium dark>
                                Nous prenons en charge tout le processus de recrutement pour vous.
                            </Text>
                        </Stack>
                    </FlexRow>
                    <FlexRow gap={2}>
                        <i className="fi fi-br-time-fast" style={{ fontSize: 32 }} />
                        <Stack style={{ flex: 1 }}>
                            <Text size={16} medium dark>
                                Gagnez du temps et réduisez vos délais de recrutement jusqu’à 70%
                            </Text>
                        </Stack>
                    </FlexRow>
                    <FlexRow gap={2}>
                        <i className="fi fi-br-badge" style={{ fontSize: 32 }} />
                        <Stack style={{ flex: 1 }}>
                            <Text size={16} medium dark>
                                Choisissez le profil idéal parmi notre sélection de talents ciblés autour de vos
                                attentes
                            </Text>
                        </Stack>
                    </FlexRow>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Stack
                    style={{
                        flex: 1,
                        gap: 16,
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Button
                        onClick={() => {
                            onConfirm();
                        }}
                        variant="contained">
                        Utiliser l’offre Premium
                    </Button>
                    <Button
                        onClick={() => {
                            onSkip();
                        }}
                        variant="text">
                        Continuer sans l’offre Premium
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default PremiumOfferDialog;
